import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type { ApiStockOptionsData, ApiStockOptionsLoadResult } from "./types";

/** Транспортный слой OMP — общие параметры СУ/УП. */
export const stockOptionsApi = {
    /**
     * Загружает общие параметры СУ (`stock/options.load`).
     * @param config опции HTTP-запроса
     */
    load: async (config?: RequestConfig): Promise<ApiStockOptionsData> => {
        const data = await ompApiClient.postOmega<ApiStockOptionsLoadResult>("stock/options.load", {}, config);

        return data.options;
    },
} as const;
